<app-report-runner
  reportType="services-provided"
  title="Services Provided Report"
  description="Services provided, completed, and unit totals during the selected period."
/>
